import { useEffect, useState } from "react";
import { IAgreementRepository, IOtherComms, IOtherCommsRows } from "../types";
type AgmtOtherCommProps = {
  agmtDetails: IAgreementRepository;
};
const AgmtOtherComms = ({ agmtDetails }: AgmtOtherCommProps) => {
  const [commissions, setCommissions] = useState<IOtherCommsRows[]>();

  useEffect(() => {
    if (
      (agmtDetails.pifMax && agmtDetails.pifMax.length > 0) ||
      (agmtDetails.pifMin && agmtDetails.pifMin.length > 0)
    ) {
      setCommissions(
        agmtDetails.pifMax?.map((x, i) => {
          return {
            otherCommissionPercentage:
              agmtDetails.otherCommissionPercentage![i],
            otherCommissionTransaction:
              agmtDetails.otherCommissionTransaction![i],
            pifMin: agmtDetails.pifMin![i],
            pifMax: agmtDetails.pifMax![i],
          };
        })
      );
    }
  }, [agmtDetails]);

  if (
    agmtDetails &&
    agmtDetails.pifMax &&
    agmtDetails.pifMax.length === 0 &&
    agmtDetails.pifMin &&
    agmtDetails.pifMin.length === 0
  ) {
    return (
      <div className="flex justify-center text-xs italic col-span-3">
        No Commission Found
      </div>
    );
  }
  return (
    <div className="divide divide-y px-8">
      {commissions?.map(
        (
          {
            otherCommissionPercentage,
            otherCommissionTransaction,
            pifMin,
            pifMax,
          },
          i
        ) => {
          return (
            <div key={i} className="grid grid-cols-6 text-xs p-2">
              <div className="col-span-4 grid gap-y-2">
                <div className="grid grid-cols-3 gap-2">
                  <div className="col-span-2 text-gray-700">
                    Contingency Commission:
                  </div>
                  <div className="font-semibold">
                    {otherCommissionPercentage
                      ? parseFloat(otherCommissionPercentage).toFixed(2) + "%"
                      : otherCommissionPercentage}
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-2">
                  <div className="col-span-2 text-gray-700">
                    Contingency Commission Transaction:
                  </div>
                  <div className="font-semibold">
                    {otherCommissionTransaction
                      ? parseFloat(otherCommissionTransaction).toFixed(2) + "%"
                      : otherCommissionTransaction}
                  </div>
                </div>
              </div>
              <div className="col-span-2 grid gap-y-2">
                <div className="grid grid-cols-2 gap-2">
                  <div className="text-gray-700 ">PIF Min:</div>
                  <div className="font-semibold">
                    {pifMin
                      ? parseFloat(pifMin.toString()).toFixed(2) + "%"
                      : pifMin}
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div className="text-gray-700 ">PIF Max:</div>
                  <div className="font-semibold">
                    {pifMax
                      ? parseFloat(pifMax.toString()).toFixed(2) + "%"
                      : pifMax}
                  </div>
                </div>
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};

export default AgmtOtherComms;
